const data = [
  // Recipe Book
  {
    id: "I9UYiWftXx",
    order: 1,
    title: "Recipe Book",
    dates: "May 2014 - September 2015",
    duties: [
      "Display a list of pre-selected recipes, with basic information in the home page.",
      "User can toggle which category they want to see by pressing the buttons in the top, making the list sort the items in that category.",
      "Each recipe has a button that takes the user to a specific page, containing more information about the recipe, ingredients and step-by-step instructions.",
    ],
    company: "React",
    demoLink: "https://recepie-book.netlify.app/",
    githubLink: "https://github.com/GiovaneForlenza/recipe-book",
    img: "./images/restaurant-menu.png",
  },
  {
    id: "I9UYiWftXz",
    order: 1,
    title: "Movie List (WIP)",
    dates: "May 2014 - September 2015",
    duties: [
      "Displays a selection of movies and TV Series from an external API (TheMovieDB)",
      "User can toggle search for specific movies using the real time updated search bar and/or the genre selection",
      "Each movie displays the title, the genres and which platform it's available to watch in Canada",
    ],
    company: "React",
    demoLink: "https://best-movie-list-to-ever-exist.netlify.app/",
    githubLink: "https://github.com/GiovaneForlenza/Movie-List",
    img: "./images/movie-list-home.png",
  },
  // Cocktail Selection
  {
    id: "YRO1t6KIgZ",
    order: 1,
    title: "Cocktail Selection",
    dates: "May 2014 - September 2015",
    duties: [
      "Project uses React components alongside with an external API to fetch information about cocktails.",
      "User can search for a specific cocktail and clicking the ‘details’ button will redirect the user to a page with more information about the cocktail.",
    ],
    company: "React",
    demoLink: "https://react-project-cocktaildb.netlify.app/",
    githubLink: "https://github.com/GiovaneForlenza/cocktail-db",
    img: "./images/cocktail.png",
  },
  // Product Review
  {
    id: "4jgSfl41Va",
    order: 3,
    title: "Product Review",
    dates: "December 2015 - Present",
    duties: [
      "Project uses React elements to display a list of reviews from a product or service, displaying the image, name, job and quote left in the review.",
      "User can navigate trough the reviews pressing the buttons or select a random review clicking in the 'Surprise Me' button.",
    ],
    company: "React",
    demoLink: "https://react-project-reviews-app.netlify.app/",
    githubLink: "https://github.com/GiovaneForlenza/product-review",
    img: "./images/review-app.png",
  },
  // Color HUE Generator
  {
    id: "4tjNWlYmLM",
    order: 2,
    title: "Color HUE Generator",
    dates: "May 2015 - December 2015",
    duties: [
      "This projects uses an external library to generate variations of a HEX color, and places it into Reject elements.",
      "Generates 20 variations of a single color, with a 10% variation on the HUE of the color.",
    ],
    company: "React",
    demoLink: "https://react-project-colorgenerator.netlify.app/",
    githubLink: "https://github.com/GiovaneForlenza/color-hue-generator",
    img: "./images/color-hue.png",
  },
  // Accordions
  {
    id: "9JMkYMPw6I",
    order: 1,
    title: "Accordions",
    dates: "May 2014 - September 2015",
    duties: [
      "Presents how a list of accordions would work, with the ability to show/hide information on click.",
      "Titles and descriptions on each accordion is easily editable with a Reject element.",
    ],
    company: "React",
    demoLink: "https://react-projects-accordions.netlify.app/",
    githubLink: "https://github.com/GiovaneForlenza/accordions",
    img: "./images/accordions.png",
  },
  // Grocery List
  {
    id: "QlN3unOX5J",
    order: 1,
    title: "Grocery List",
    dates: "May 2014 - September 2015",
    duties: [
      "Project created using React allows user to Create, Edit and Delete items from a list.",
      "Designed to save the list into the browser’s local storage.",
    ],
    company: "React",
    demoLink: "https://react-projects-grocery-list.netlify.app/",
    githubLink: "https://github.com/GiovaneForlenza/grocery-list",
    img: "./images/grocery-list.png",
  },
];

export default data;
